import "core-js/modules/es.array.concat.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NUDGE_ROUTES } from 'utils/nudges/getNudgePath';
import { hasPrivilege, NUDGE_WRITE } from 'utils/privileges';
import { AdminOrHubButtonLink } from 'components/AdminOrHubLink';
import InlineList from 'components/InlineList';
import TitleCard from 'components/TitleCard';
import NudgesTable from './NudgesTable';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NudgesOverviewCard(_ref) {
  var contentId = _ref.contentId,
    type = _ref.type,
    variant = _ref.variant;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var nudgesLocation = "".concat(NUDGE_ROUTES.root, "?search=").concat(encodeURIComponent("content:".concat(contentId)));
  if (!hasPrivilege(NUDGE_WRITE)) {
    return null;
  }
  return /*#__PURE__*/_jsx(TitleCard, {
    title: t('content_type_nudge_plural'),
    sideContent: /*#__PURE__*/_jsxs(InlineList, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsx(AdminOrHubButtonLink, {
        to: nudgesLocation,
        size: "medium",
        children: t('actions_view_all')
      }), /*#__PURE__*/_jsx(AdminOrHubButtonLink, {
        size: "medium",
        icon: "plus",
        variant: "primary",
        to: "".concat(NUDGE_ROUTES.newContent, "?").concat(type, "Id=").concat(contentId),
        children: t('actions_add_nudge')
      })]
    }),
    description: t('content_nudges_card_description'),
    fontSize: "s",
    variant: variant,
    children: /*#__PURE__*/_jsx(NudgesTable, {
      contentId: contentId,
      type: type
    })
  });
}
export default NudgesOverviewCard;